import { createI18n } from 'vue-i18n';
import pl from '../locales/pl.json';
import en from '../locales/en.json';

const savedLocale = localStorage.getItem('locale') ?? 'pl';

export const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'pl',
  messages: { pl, en },
});

export type Locale = 'pl' | 'en';

export function getI18nT() {
  return i18n.global.t;
}
